import { render, staticRenderFns } from "./MetaContainer.vue?vue&type=template&id=1b628be7&scoped=true"
import script from "./MetaContainer.vue?vue&type=script&lang=js"
export * from "./MetaContainer.vue?vue&type=script&lang=js"
import style0 from "./MetaContainer.vue?vue&type=style&index=0&id=1b628be7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b628be7",
  null
  
)

export default component.exports